<template>
  <div class="grid-universal-footer">
    <AudienceCTA v-if="isCtaShowing && !isParticipantEmbed" />
  </div>
</template>

<script>
import AudienceCTAContainer from '@/containers/footer/AudienceCTA'
import { mapGetters } from 'vuex'
import AudienceCTA from '@/components/footer/AudienceCTA.vue'

export default {
  components: {
    AudienceCTA: AudienceCTAContainer(AudienceCTA),
  },
  props: {
    isCtaShowing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('participantEmbed', ['isParticipantEmbed']),
  },
}
</script>

<style lang="scss" scoped>
.grid-universal-footer {
  width: 100%;
  box-sizing: border-box;
}
</style>
